/*
 * Pont Camweara ↔ bouton « Essayer en AR » du thème.
 *
 * Camweara injecte son propre bouton (#camweara-tryon-button) depuis son bloc
 * d'app, masqué par défaut, et ne l'affiche (display:flex en style inline) que
 * sur les produits présents dans leur dashboard.
 *
 * On masque leur bouton, on relaie le clic du nôtre, et on n'affiche le nôtre
 * que lorsque Camweara a reconnu le produit — pas de CTA mort sur les modèles
 * non encore configurés.
 */
(function () {
  'use strict';

  var ours = document.querySelector('.gallery__tryon');
  if (!ours) return;

  // Caché tant que Camweara n'a pas confirmé le produit.
  ours.style.display = 'none';

  // !important : leur bouton se ré-affiche via un style inline sans priorité.
  var css = document.createElement('style');
  css.textContent = '#camweara-tryon-button{display:none!important}';
  document.head.appendChild(css);

  function bind(theirs) {
    ours.addEventListener('click', function (e) {
      e.preventDefault();
      theirs.click();
    });

    function sync() {
      var shown = theirs.style.display && theirs.style.display !== 'none';
      ours.style.display = shown ? 'flex' : 'none';
    }

    sync();
    new MutationObserver(sync).observe(theirs, {
      attributes: true,
      attributeFilter: ['style']
    });
  }

  function look() {
    var theirs = document.getElementById('camweara-tryon-button');
    if (theirs) { bind(theirs); return true; }
    return false;
  }

  // Le bloc d'app est rendu plus bas dans la page : on attend son arrivée.
  if (!look()) {
    var obs = new MutationObserver(function () {
      if (look()) obs.disconnect();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 15000);
  }
})();
